import { cn } from '@avanta/shared/utils/cn';
import { type ReactElement } from 'react';
import { useLocation } from 'react-router';
import { useUserStore } from 'stores/user';
import { isMintHeader } from 'utils/nav';
import { DesktopNav } from './DesktopNav';
import { MobileNav } from './MobileNav';
import { useScrollCompactNavBar } from './hooks';

export const TopNav = (): ReactElement => {
  const scrolled = useScrollCompactNavBar();
  const pathname = useLocation().pathname;
  const user = useUserStore(state => state.user);
  const mintShell = isMintHeader(pathname, user);

  return (
    <header
      className={cn(
        'sticky top-0 z-50 transition-colors duration-200',
        'max-am-3xl:static max-am-3xl:border-b-0',
        scrolled
          ? cn('max-am-3xl:bg-white', 'am-3xl:border-b am-3xl:border-gray-200 am-3xl:bg-white')
          : mintShell
            ? cn('max-am-3xl:bg-mint-100', 'am-3xl:bg-mint-100 am-3xl:border-mint-100')
            : cn('max-am-3xl:bg-transparent', 'am-3xl:bg-white')
      )}
    >
      <DesktopNav />
      <MobileNav />
    </header>
  );
};
